var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _vm.currentTab == 0
        ? _c(
            "app-dossier-edit",
            {
              attrs: { company: _vm.company },
              model: {
                value: _vm.dossier,
                callback: function ($$v) {
                  _vm.dossier = $$v
                },
                expression: "dossier",
              },
            },
            [
              _c(
                "w-button",
                {
                  attrs: { flat: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goToCompany()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                1
              ),
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.currentTab,
                  callback: function ($$v) {
                    _vm.currentTab = $$v
                  },
                  expression: "currentTab",
                },
              }),
            ],
            1
          )
        : _vm.currentTab == 1
        ? _c(
            "app-dossier-user",
            {
              attrs: { company: _vm.company },
              model: {
                value: _vm.dossier,
                callback: function ($$v) {
                  _vm.dossier = $$v
                },
                expression: "dossier",
              },
            },
            [
              _c(
                "w-button",
                {
                  attrs: { flat: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goToCompany()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                1
              ),
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.currentTab,
                  callback: function ($$v) {
                    _vm.currentTab = $$v
                  },
                  expression: "currentTab",
                },
              }),
            ],
            1
          )
        : _vm.currentTab == 2
        ? _c(
            "app-dossier-scripts",
            {
              attrs: { company: _vm.company },
              model: {
                value: _vm.dossier,
                callback: function ($$v) {
                  _vm.dossier = $$v
                },
                expression: "dossier",
              },
            },
            [
              _c(
                "w-button",
                {
                  attrs: { flat: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goToCompany()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                1
              ),
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.currentTab,
                  callback: function ($$v) {
                    _vm.currentTab = $$v
                  },
                  expression: "currentTab",
                },
              }),
            ],
            1
          )
        : _vm.currentTab == 3
        ? _c(
            "app-dossier-calculated-fields",
            {
              attrs: { company: _vm.company },
              model: {
                value: _vm.dossier,
                callback: function ($$v) {
                  _vm.dossier = $$v
                },
                expression: "dossier",
              },
            },
            [
              _c(
                "w-button",
                {
                  attrs: { flat: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goToCompany()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                1
              ),
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.currentTab,
                  callback: function ($$v) {
                    _vm.currentTab = $$v
                  },
                  expression: "currentTab",
                },
              }),
            ],
            1
          )
        : _vm.currentTab == 4
        ? _c(
            "app-browse-extra-buttons",
            {
              attrs: { company: _vm.company },
              model: {
                value: _vm.dossier,
                callback: function ($$v) {
                  _vm.dossier = $$v
                },
                expression: "dossier",
              },
            },
            [
              _c(
                "w-button",
                {
                  attrs: { flat: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goToCompany()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                1
              ),
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.currentTab,
                  callback: function ($$v) {
                    _vm.currentTab = $$v
                  },
                  expression: "currentTab",
                },
              }),
            ],
            1
          )
        : _vm.currentTab == 5
        ? _c(
            "app-dossier-auto-sale-row-settings",
            {
              attrs: { company: _vm.company },
              model: {
                value: _vm.dossier,
                callback: function ($$v) {
                  _vm.dossier = $$v
                },
                expression: "dossier",
              },
            },
            [
              _c(
                "w-button",
                {
                  attrs: { flat: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goToCompany()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                1
              ),
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.currentTab,
                  callback: function ($$v) {
                    _vm.currentTab = $$v
                  },
                  expression: "currentTab",
                },
              }),
            ],
            1
          )
        : _vm.currentTab == 6
        ? _c(
            "app-dossier-peppol-registrations-edit",
            { attrs: { dossier: _vm.dossier, company: _vm.company } },
            [
              _c(
                "w-button",
                {
                  attrs: { flat: "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goToCompany()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                1
              ),
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.currentTab,
                  callback: function ($$v) {
                    _vm.currentTab = $$v
                  },
                  expression: "currentTab",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }